// Dynamic Diesels — Reviews scroller controls.
// Prev/next arrows scroll by one card width (+ gap) with smooth behavior.
// Disables arrows when at start/end of the scroll range.

(function () {
  'use strict';

  const GAP_PX = 20;

  function init() {
    document.querySelectorAll('.dd-reviews').forEach((section) => {
      const scroller = section.querySelector('.dd-reviews__scroller');
      const prev = section.querySelector('.dd-reviews__arrow--prev');
      const next = section.querySelector('.dd-reviews__arrow--next');
      if (!scroller) return;

      const scrollByCard = (dir) => {
        const card = scroller.querySelector('.dd-reviews__card');
        if (!card) return;
        const distance = (card.offsetWidth + GAP_PX) * dir;
        scroller.scrollBy({ left: distance, behavior: 'smooth' });
      };

      const updateArrows = () => {
        if (!prev || !next) return;
        const max = scroller.scrollWidth - scroller.clientWidth;
        prev.disabled = scroller.scrollLeft <= 4;
        next.disabled = scroller.scrollLeft >= max - 4;
      };

      if (prev) prev.addEventListener('click', () => scrollByCard(-1));
      if (next) next.addEventListener('click', () => scrollByCard(1));

      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
